import React, { useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  InputAdornment,
  TextField,
  Select,
  FormControl,
  MenuItem,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import "./bylevelchart.scss";
import { useQuery } from "@apollo/client";

import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

import { GET_STUDENT_STUDENT_DROP_OUT_SHOW_BY_GROUP } from "../../../Schema/Dashboard";
import LoadingPage from "../../Include/LoadingPage";

export default function DropOutChartByLevel({ academicYearId, schoolId, levelId, levelName }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [totalData, setTotalData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(GET_STUDENT_STUDENT_DROP_OUT_SHOW_BY_GROUP, {
    variables: {
      academicYearId: academicYearId ?? null,
      schoolId: schoolId ?? null,
      levelId: levelId ?? null
    },
    onCompleted: ({ getStudentDropOutChartShowByGroup }) => {
      setTotalData(getStudentDropOutChartShowByGroup);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const groupData = totalData?.map((e) => {
    return t("group") + " " + e?.groupName;
  });

  const totalStudent = totalData?.map((e) => e?.totalStudent);
  const totalFemale = totalData?.map((e) => e?.female);

  const maxSeriesData = Math.max(...(totalStudent?.length ? totalStudent : []));

  useEffect(() => {
    refetch();
  }, [academicYearId, schoolId, levelId]);

  const state = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        fontFamily: "Khmer OS Siemreap",
        stacked: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return val;
          } else {
            return "0";
          }
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: groupData,
        // categories: ["A", "B", "C", "D", "E"],
      },
      yaxis: {
        // max: maxSeriesData + 5,
        labels: {
          style: {
            fontFamily: "Siemreap",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val + " នាក់";
            } else {
              return 0 + " នាក់";
            }
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: [
      {
        name: t("total_student"),
        data: totalStudent,
        // data: [10, 15, 20, 25, 30],
        color: "#F44236",
      },
      {
        name: t("total_female"),
        data: totalFemale,
        // data: [5, 10, 15, 20, 25],
        color: "#FEC009",
      },
    ],
  };

  return (
    <Box className="total-enrollment-by-level-chart">
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography
          className={language === "en" ? "chart-title" : "chart-title-kh"}
        >
          {t("total_drop_out_chart_by_level")} {levelName}
        </Typography>
      </Stack>

      {
        loading ? <LoadingPage /> :
          <div id="chart">
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="bar"
              height={350}
            />
          </div>
      }
    </Box>
  );
}
